import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Typography from "@mui/material/Typography";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Board from "../Board";
import {Day} from "../core/Day";
import {Option} from "../core/Option";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import HomeIcon from "@mui/icons-material/Home";
import Person2Icon from "@mui/icons-material/Person2";
import {redirect, useNavigate} from "react-router";
import {IBoard, IBoardData, parseBoard, serializeBoard} from "../core/IBoard";
import {useSnackbar} from "notistack";
import {MAIN_BACKGROUND_COLOR, MAIN_ICON_COLOR} from "../CONSTANTS";
import {getBoards, saveBoard} from "../helper_functions";

export function MainPage() {
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const [year, setYear] = useState(new Date().getFullYear());

    const [boards, setBoards] = useState<IBoard[]>([]);

    const APP_VERSION = "v1.0.4";

    const handlePreviousYear = () => {
        setYear((currentYear) => --currentYear);
    }

    const handleNextYear = () => {
        setYear((currentYear) => Math.min(++currentYear, new Date().getFullYear()));
    }

    const handleBoardClick = (board: number | undefined) => {

        const serializedBoard = serializeBoard(boards[0]);



        navigate(`board/${board}/${year}`);
    }

    const handleBoardCreation = () => {

        let nextID = 1;
        if(boards.length > 0)
        {
            nextID = boards[boards.length-1].id + 1;
        }

        const emptyBoard: IBoard = {

            id: nextID,
            title: "my log...",
            data: [],
            availableOptions: []

        }

        saveBoard(emptyBoard);
        setBoards((currBoards) => [...currBoards, emptyBoard]);
        enqueueSnackbar('New board created', { variant: "success" });
    }

    /**
     * @returns the number of loaded boards
     */


    useEffect(() => {

        const storedBoards = getBoards();

        if(storedBoards.length !== 0)
        {
            setBoards(storedBoards);
        }
        // else
        // {
        //     const initialBoards = [
        //
        //         {
        //             id: 0,
        //             title: "Health log",
        //             data: [
        //                 {
        //                     year: year,
        //                     days: new Map<number, Day>([
        //                         [1, new Day(new Set<Option>([ new Option("Ate apple", "#77c265") ]), "Healff")],
        //                         [10, new Day(new Set<Option>([ new Option("Cried", "#464dff"), new Option("Ate apple", "#77c265") ]), "Healff")],
        //                     ])
        //                 }
        //             ],
        //             availableOptions: [
        //                 new Option("Cried", "#464dff"),
        //                 new Option("Ate apple", "#77c265")
        //             ]
        //         }
        //
        //     ];
        //
        //     setBoards(initialBoards);
        //
        //     initialBoards.forEach((initialBoard) => {
        //         saveBoard(initialBoard);
        //     });
        //
        // }

    }, [])

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100dvw',
            height: '100dvh',
            backgroundColor: 'white',
            fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        }}>
            <Box sx={{ position: 'absolute', right: 16, display: 'flex', gap: 2 }}>
                <Typography variant={'subtitle2'}>{APP_VERSION}</Typography>
            </Box>

            <Box className={"heading"} sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Box sx={{ p: 2, }}>
                    <img src={'carlipixa.png'} width={'auto'} height={'80px'} />
                </Box>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        size="large"
                        variant="text"
                        onClick={handlePreviousYear}
                        sx={{color: '#afafaf'}}
                    >
                        <ArrowBackIosIcon />
                    </Button>
                    <Typography sx={{margin: 'auto'}}>{year}</Typography>
                    <Button
                        size="large"
                        variant='text'
                        onClick={handleNextYear}
                        sx={{color: '#afafaf'}}
                    >
                        <ArrowForwardIosIcon />
                    </Button>
                </Box>
            </Box>

            <Box className={"boards"} sx={{ overflowY: 'scroll', flexGrow: 1 }}>

                <Box sx={{
                    borderRadius: 0,
                    mt: 2,
                    minHeight: 'calc(100% - 2 * 8px)',  //m: 2 -> 1x m = 8px
                    backgroundColor: MAIN_BACKGROUND_COLOR
                }}>

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(2, 1fr)',
                            gridColumnGap: '16px',
                            gridRowGap: '16px',
                            p: 2,
                        }}
                    >

                        {
                            boards.map((board, index) => {

                                return (

                                    <Board
                                        id={index}
                                        selectedYear={year}
                                        key={'user-defined-board-' + index}
                                        title={board.title}
                                        data={board.data}
                                        availableOptions={board.availableOptions}
                                        onClick={() => handleBoardClick(board.id)}
                                    />
                                )

                            })
                        }

                        <Paper
                            sx={{
                                height: '300px',
                                p: 1,
                                color: '#cbcbcb'
                            }}
                            onClick={() => handleBoardCreation()}
                        >
                            <Box sx={{ display: 'flex', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                <AddCircleIcon />
                            </Box>
                        </Paper>

                    </Box>

                </Box>

            </Box>

            <Box className={'navigation'} sx={{display: 'flex', p: 2, justifyContent: 'space-between'}}>
                <Box sx={{width: '100%', textAlign: 'center'}}>
                    <Button
                        size="large"
                        variant="text"
                        sx={{color: MAIN_ICON_COLOR}}
                        onClick={() => navigate('/') }
                    >
                        <HomeIcon />
                    </Button>
                </Box>
                <Box sx={{width: '100%', textAlign: 'center'}}>
                    <Button
                        size="large"
                        variant="text"
                        sx={{color: '#afafaf'}}
                        onClick={() => navigate('settings') }
                    >
                        <Person2Icon />
                    </Button>
                </Box>
            </Box>


        </Box>
    );
}